<h1 class="ui header">Custom Login Page with Sign In Widget</h1>
<div>
  <p>{{message}}</p>
</div>
